const EMPTY_CONTEXT = Object.freeze({ organizationId: null, generation: 0 })

let context = EMPTY_CONTEXT
let accessInvalidatedHandler = null

function normalizeOrganizationId(value) {
	const normalized = String(value ?? '')
	return /^[1-9]\d*$/.test(normalized) ? normalized : null
}

export function getTenantContextSnapshot() {
	return context
}

export function beginTenantContextTransition() {
	context = Object.freeze({ organizationId: null, generation: context.generation + 1 })
	return context
}

export function acceptTenantContext(organizationId, generation) {
	const normalized = normalizeOrganizationId(organizationId)
	if (!normalized || generation !== context.generation) return false
	context = Object.freeze({ organizationId: normalized, generation })
	return true
}

export function clearTenantContext() {
	return beginTenantContextTransition()
}

export function isTenantGenerationCurrent(generation) {
	return generation === context.generation
}

export function setTenantAccessInvalidatedHandler(handler) {
	accessInvalidatedHandler = typeof handler === 'function' ? handler : null
}

export function notifyTenantAccessInvalidated(details) {
	accessInvalidatedHandler?.(details)
}

export function resetTenantContextForTests() {
	context = EMPTY_CONTEXT
	accessInvalidatedHandler = null
}
